import React from "react";
import { ArrowRight, BookOpen, CircleQuestionMark as HelpCircle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
interface ServiceItem {
  title: string;
  description: string;
  to: string;
  image: {
    src: string;
    srcset: string;
    sizes: string;
    alt: string;
  };
}
const services: ServiceItem[] = [{
  title: "Kitchen Remodeling",
  description: "Custom cabinetry, chef-grade appliances, quartz islands, and open-concept layouts tailored for living and entertaining.",
  to: "/KitchenRemodelingPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_remodeling_luxury.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_remodeling_luxury.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_remodeling_luxury.webp-wvc-sizes",
    alt: "Renovated luxury kitchen with white oak cabinets, marble island, and designer pendant lighting in Brookhaven"
  }
}, {
  title: "Bathroom Remodeling",
  description: "Spa-grade primary suites, curbless walk-in showers, freestanding soaking tubs, and custom vanities.",
  to: "/BathroomRemodelingPage",
  image: {
    src: "/img/bathroom_remodeling_spa.webp",
    srcset: "/img/bathroom_remodeling_spa.webp-wvc-srcset",
    sizes: "/img/bathroom_remodeling_spa.webp-wvc-sizes",
    alt: "Primary bathroom remodel featuring a freestanding bathtub, glass-enclosed shower, and brushed brass fixtures"
  }
}, {
  title: "Whole-Home Remodeling",
  description: "Comprehensive structural reconfiguration, elevated architectural finishes, and unified interior flows.",
  to: "/WholeHomeRemodelingPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/whole_home_remodeling_interior.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/whole_home_remodeling_interior.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/whole_home_remodeling_interior.png-wvc-sizes",
    alt: "Bright, open-concept whole-home renovation with hardwood flooring and continuous architectural moldings"
  }
}, {
  title: "Home Additions",
  description: "Seamless second-story extensions, expanded family rooms, and ground-up primary suite wings built to match your home.",
  to: "/HomeAdditionsPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/home_addition_exterior.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/home_addition_exterior.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/home_addition_exterior.png-wvc-sizes",
    alt: "Architectural home addition with cohesive brick facade, large grid windows, and covered entrance"
  }
}, {
  title: "Basement Remodeling",
  description: "Finished terrace levels featuring custom wet bars, home theaters, guest suites, and home fitness studios.",
  to: "/BasementRemodelingPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/basement_remodel_finished.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/basement_remodel_finished.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/basement_remodel_finished.png-wvc-sizes",
    alt: "Modern finished basement lounge with built-in bar, recessed lighting, and entertainment seating"
  }
}, {
  title: "Interior Remodeling",
  description: "Millwork upgrades, structural wall removals, coffered ceilings, and tailored layout modernization across living areas.",
  to: "/InteriorRemodelingPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/interior_remodel_living_space.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/interior_remodel_living_space.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/interior_remodel_living_space.png-wvc-sizes",
    alt: "Renovated living room with bespoke fireplace surround, custom built-ins, and natural daylight"
  }
}, {
  title: "Outdoor Living",
  description: "Covered stone patios, outdoor kitchens, fire pits, and screened porches designed for year-round entertaining.",
  to: "/OutdoorLivingPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/outdoor_living_patio.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/outdoor_living_patio.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/outdoor_living_patio.png-wvc-sizes",
    alt: "Covered outdoor living pavilion with cedar tongue-and-groove ceiling, stone hearth, and dining space"
  }
}, {
  title: "Deck Remodeling",
  description: "Composite low-maintenance decking, modern railing systems, multi-tier platforms, and integrated stair lighting.",
  to: "/DeckRemodelingPage",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/deck_remodeling_composite.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/deck_remodeling_composite.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/deck_remodeling_composite.png-wvc-sizes",
    alt: "Multi-level composite deck installation with black cable railings overlooking a wooded backyard"
  }
}];
export default function ServicesOverview() {
  return <section id="servicesoverview" data-nav="light" className="bg-background text-foreground py-20 lg:py-28 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mb-14 lg:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-foreground">
            Comprehensive residential remodeling services
          </h2>
          <p className="mt-4 text-lg text-foreground/80 leading-relaxed font-default">
            From focused kitchen transformations to whole-home structural additions, our Brookhaven craftsmen deliver uncompromising finish quality and clear project management.
          </p>
        </div>

        {/* 8 Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {services.map((service, index) => <Card key={service.title} data-index={index} className="group border border-border bg-card shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col justify-between">
              <div>
                <div className="relative aspect-[4/3] w-full overflow-hidden bg-muted">
                  <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <CardContent className="pt-6 pb-2">
                  <h3 className="font-serif text-xl font-medium text-card-foreground group-hover:text-primary transition-colors">
                    {service.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground/75 leading-relaxed font-default">
                    {service.description}
                  </p>
                </CardContent>
              </div>

              <div className="p-6 pt-2">
                <Button asChild variant="ghost" className="w-full justify-between px-0 font-medium text-foreground hover:text-primary hover:bg-transparent">
                  <Link to={service.to} className="inline-flex items-center gap-2">
                    <span>Explore service</span>
                    <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </Card>)}
        </div>

        {/* Additional Planning & FAQ Resources */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-6 sm:p-8 rounded-xl border border-border bg-card flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-start gap-4">
              <div className="p-3 rounded-lg bg-accent text-accent-foreground shrink-0">
                <BookOpen className="size-6 text-primary" />
              </div>
              <div>
                <h4 className="font-serif text-lg font-medium text-card-foreground">
                  Remodeling Planning Guide
                </h4>
                <p className="mt-1 text-sm text-foreground/75 font-default">
                  Essential steps, realistic budgets, and timeline advice before breaking ground.
                </p>
              </div>
            </div>
            <Button asChild variant="outline" className="shrink-0 w-full sm:w-auto">
              <Link to="#">Read guide</Link>
            </Button>
          </div>

          <div className="p-6 sm:p-8 rounded-xl border border-border bg-card flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-start gap-4">
              <div className="p-3 rounded-lg bg-accent text-accent-foreground shrink-0">
                <HelpCircle className="size-6 text-primary" />
              </div>
              <div>
                <h4 className="font-serif text-lg font-medium text-card-foreground">
                  Frequently Asked Questions
                </h4>
                <p className="mt-1 text-sm text-foreground/75 font-default">
                  Answers regarding permitting, design phases, material choices, and warranties.
                </p>
              </div>
            </div>
            <Button asChild variant="outline" className="shrink-0 w-full sm:w-auto">
              <Link to="#">View FAQ</Link>
            </Button>
          </div>
        </div>

        {/* Personalized Estimate CTA */}
        <div className="mt-12 rounded-2xl bg-secondary text-secondary-foreground p-8 sm:p-12 border border-secondary/20 shadow-md">
          <div className="max-w-3xl flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <h3 className="font-serif text-2xl sm:text-3xl font-medium tracking-tight">
                Ready to plan your renovation project?
              </h3>
              <p className="mt-2 text-base text-secondary-foreground/80 font-default leading-relaxed">
                Connect with our Brookhaven design and build team for an on-site consultation and clear, upfront pricing.
              </p>
            </div>
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-medium shrink-0 self-start md:self-auto">
              <Link to="/ContactRequestAnEstimatePage">
                <span>Request an estimate</span>
                <ArrowRight className="size-4 ml-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}